import {PlanningCable} from './planning-cable';

export class PlanningNode {
  nodeGridelementId: number;
  gridelementId: string;
  offsetActivePowerKW: number;
  offsetReactivePowerCosPhi: number;
}
